module.exports = __webpack_public_path__ + "static/media/happy.7c1da1c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/happy.svg
// module id = 1125
// module chunks = 0